<template>
    <div class="home">
        <b-container fluid>
            <h1>Order Minnesota Vital Records</h1><br>
            <b-row>
              <b-col>
                <p>
                  Welcome to the Minnesota Department of Health - Office of Vital Records online ordering and e-payment system.
                </p>
              </b-col>
            </b-row>
            <h2 class="mt-3">How It Works</h2>
            <b-row>
                <b-col cols="12" lg="10">
                  <p>
                    Use this site to order vital records products, services, and searches of the Fathers’ Adoption Registry from the Minnesota Department of Health (MDH). Some vital records products and services require you to upload documents, and some require you to send original documents to MDH.
                  </p>
                  <p>
                    If you cannot find a product or service that you need, see the
                      <a href="https://www.health.state.mn.us/people/vitalrecords/birthnc.html" class="mdh-green-link" target="_blank">Available Records and Services Page - opens in new tab</a> or contact the MDH Office of Vital Records.
                  </p>
                </b-col>
            </b-row>
            <h2 class="mt-3">Before You Order</h2>
            <b-row>
                <b-col cols="12" lg="10">
                    To avoid delays, review these important details before starting your order:
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" class="mt-4">
                Create an Account if you want to save an incomplete order or you will have to start over.
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="3">
                <b-button variant="primary" href="/register" class="mr-3 mt-3"> Create an Account </b-button>
              </b-col>
              <b-col cols="12" md="3">
                <b-button variant="primary" @click="login" class="mr-3 mt-3"> Account Login </b-button>
              </b-col>
              <b-col cols="12" md="3">
                <b-button variant="primary" @click="toProductSelect" class="mt-3"> Start Order </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="10" style="margin-left: 10px;" class="mt-4 mb-4">
                    <ul>
                        <li>• You will need to prove your identity and eligibility to order some products. The system will tell you if you must upload a notarized application. </li>
                        <li>• You may need to provide documentation to complete your order. The system will tell you if you must upload documents or mail us original documents.</li>
                        <li>• Review processing times on the <a href="https://www.health.state.mn.us/people/vitalrecords/index.html" class="mdh-green-link" target="_blank">MDH Vital Records and Certificates page - opens in new tab</a> to help you estimate how long it will take us to fulfill your order.</li>
                        <li>• You may be able to get some products faster from a county vital records office.</li>
                        <li>• You must pay and provide any required documents before we can process your order.</li>
                        <li>• You cannot cancel an order after you have paid.</li>
                        <li>• Submit your order to the Office of Vital Records by mail if you do not want to order online.</li>
                        <li>• Visit the <a href="/faq" class="mdh-green-link" target="_blank">Frequently Asked Questions - opens in new tab</a> page for more information. </li>
                        <li>• Contact the MDH Office of Vital Records if you need help.</li>
                    </ul>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import LocalStorageService from "@/common/LocalStorageService";

    const localStorageService = LocalStorageService.getService();

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data: () => ({
        }),
        created() {
            document.title = "Online Storefront"
        },
        methods: {
            login () {
               window.location.replace('/home')
            },
            toProductSelect() {
              localStorageService.clearCartItems()
              localStorageService.clearOrderNumber()
              localStorageService.clearOrderType()
              localStorageService.clearIsDraft()
              this.$emit('update-order')
              this.$emit('cart-update')
              this.$router.push("/product-select");
            },
        }
    }
</script>

<style>
</style>
